module.exports = __webpack_public_path__ + "img/gv-learning-1.1defa72e.png";